import { render, staticRenderFns } from "./MoviesCards.vue?vue&type=template&id=c9391fe2&scoped=true&"
import script from "./MoviesCards.vue?vue&type=script&lang=js&"
export * from "./MoviesCards.vue?vue&type=script&lang=js&"
import style0 from "./MoviesCards.vue?vue&type=style&index=0&id=c9391fe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9391fe2",
  null
  
)

export default component.exports